import script from "./banner-top.vue?vue&type=script&setup=true&lang=js"
export * from "./banner-top.vue?vue&type=script&setup=true&lang=js"

import "./banner-top.vue?vue&type=style&index=0&id=3226a31e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3226a31e"]])

export default __exports__